var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 11.25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 .938v9.375a.92.92 0 0 1-.937.938h-.937V2.742L7.5 6.781 1.875 2.742v8.508H.938A.92.92 0 0 1 0 10.313V.938A.92.92 0 0 1 .938 0h.312L7.5 4.531 13.75 0h.313A.92.92 0 0 1 15 .938"
  })));
};
export default SvgGmail;